import Partner from '@/models/Partner.js';

export default {
  namespaced: true,
  state: {
    preference: {}
  },
  mutations: {
    setPreference(state, preference) {
      state.preference = preference;
    },
  },
  actions: {
    setPreference({commit}, preference) {
      commit('setPreference', preference);
    },

    async fetchPreference({commit}) {
      const record = new Partner();
      const partner = await record.fetch();
      commit('setPreference', partner);
    },
  },
  getters: {
    currentPreference(state) {
      return state.preference;
    },
  }
}
